/* REVELASHION — compte à rebours de la page "bientôt en ligne".
   Lit la date cible depuis data-countdown (ISO 8601) et met à jour
   4 tuiles (jours/heures/min/sec) chaque seconde. */
(() => {
  const el = document.querySelector('[data-countdown]');
  if (!el) return;

  const target = new Date(el.dataset.countdown).getTime();
  if (Number.isNaN(target)) return;

  const daysEl = el.querySelector('[data-cd-days]');
  const hoursEl = el.querySelector('[data-cd-hours]');
  const minsEl = el.querySelector('[data-cd-mins]');
  const secsEl = el.querySelector('[data-cd-secs]');

  const pad = (n) => String(n).padStart(2, '0');

  let timer;
  const tick = () => {
    const diff = Math.max(0, target - Date.now());
    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const mins = Math.floor((diff % 3600000) / 60000);
    const secs = Math.floor((diff % 60000) / 1000);

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minsEl) minsEl.textContent = pad(mins);
    if (secsEl) secsEl.textContent = pad(secs);

    if (diff <= 0) clearInterval(timer);
  };

  tick();
  timer = setInterval(tick, 1000);
})();
